export default "__VITE_ASSET__JJlLwTIB__"